import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'

import { makeUrlConsignmentArchive } from './connectionData.tsx'
import { useAuth } from './useAuth.tsx'

interface ApiParams {
  _id: string
  cause: string
  by: string
}
const apiUrl = makeUrlConsignmentArchive()

const useConsignmentArchive = () => {
  const [errorConsignmentArchive, setErrorConsignmentArchive] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const { userData } = useAuth()

  const consignmentArchive = async (_id: string, cause: string) => {
    setLoading(true)

    try {
      const by = userData?.profile?._id ?? ''
      const apiParams: ApiParams = { _id, cause, by }
      await customPost(apiUrl, apiParams)

      setErrorConsignmentArchive(null)
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorConsignmentArchive(err)
      } else {
        setErrorConsignmentArchive(new Error('An unknown error occurred'))
      }
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorConsignmentArchive, loading, consignmentArchive }
}
export default useConsignmentArchive
